import $ from 'jquery';
import { createMap } from 'map';

$(() => {
    $('#summaryMap').css({ marginBottom: '20px' });
    createMap("maproute", null, ['streetView'], {}, [])
        .then(vdMap => {
            if (gpxPaths && gpxPaths.length > 0) {
                gpxPaths.forEach(wkt => vdMap.addSection(wkt, true));
                vdMap.zoomToContents();
            }
        });
});
